export const siteName = 'Cruz.com'
export const webBaseUrl = 'https://www.cruz.com'
export const totalSitemapFiles = 43

// single sign on
export const googleClientId = '299920057267-gqvujauop02p7pbmjavhos7kovu3tpij.apps.googleusercontent.com'
export const facebookAppId = '961959909117791'
export const appleClientId = 'com.cruz.signin'

// google tag manager Id
export const gtmId = 'GTM-57DX3DV'
export const isProd = (process.env.NEXT_PUBLIC_ENV_NAME === 'prod')

// aws
export const AWS = {
  dev: {
    s3: 'https://cruzdev.s3.amazonaws.com',
    cdn: 'https://img.cruz.com'
  },
  prod: {
    s3: 'https://cruzs3.s3.amazonaws.com',
    cdn: 'https://img.cruz.com'
  }
}

// pages
export const pages = {
  home: {
    name: siteName,
    href: '/',
    description: 'Shop our collection of for sale, open to offers to find your next vehicle that fits your life.'
  },
  // info
  aboutUs: {
    name: 'About Us',
    href: '/info/about-us',
    description: `About ${siteName}`
  },
  contactUs: {
    name: 'Contact Us',
    href: '/info/contact-us',
    description: 'Contact us for any questions, comments, or concerns you may have.'
  },
  privacyPolicy: {
    name: 'Privacy Policy',
    href: '/info/privacy-policy',
    description: 'Learn about our privacy practices and how we protect your personal information.'
  },
  termsConditions: {
    name: 'Terms & Conditions',
    href: '/info/terms-conditions',
    description: 'Review the terms and conditions that govern your use of our website and services.'
  },
  siteMap: {
    name: 'Site Map',
    href: '/info/site-map',
    description: 'Explore the structure of our website and find links to all pages.'
  },
  // for dealers
  forDealers: {
    name: 'For Dealers',
    href: '/for-dealers',
    description: `List your inventory with no contracts, no setup fees — just easy, risk-free exposure.`
  },
  // auth
  joinCruz: {
    name: 'Join Cruz',
    href: '/auth/join-cruz',
    description: `Join ${siteName}`
  },
  signIn: {
    name: 'Sign In',
    href: '/auth/sign-in',
    description: `Sign in to ${siteName}`
  },
  resetPassword: {
    name: 'Reset Password',
    href: '/auth/reset-password/[token]',
    description: `Reset your password for ${siteName}`
  },
  forgotPassword: {
    name: 'Forgot Password?',
    href: '/auth/forgot-password',
    description: `Forgot your password? Reset it for ${siteName}`
  },
  // my cruz
  myCruz: {
    name: 'My Cruz',
    href: '/my',
    description: `Manage your account on ${siteName}`
  },
  myProfile: {
    name: 'Profile',
    href: '/my/profile'
  },
  myPassword: {
    name: 'Change Password',
    href: '/my/change-password'
  },
  myVehicles: {
    name: 'My Vehicles',
    href: '/my/vehicle'
  },
  mySpotted: {
    name: 'My Spotted',
    href: '/my/spotted'
  },
  mySavedSearch: {
    name: 'Saved Searches',
    href: '/my/saved/searches'
  },
  mySavedVehicle: {
    name: 'Saved Vehicles',
    href: '/my/saved/vehicles'
  },
  myInquiries: {
    name: 'Inquiries',
    href: '/my/inquiries'
  },
  // my spotted
  postSpotted: {
    name: 'Post Spotted',
    href: '/my/spotted/post'
  },
  // my vehicle
  postVehicle: {
    name: 'Post Vehicle',
    href: '/my/vehicle/post'
  },
  postVehiclePre1981: {
    name: 'Post Vehicle (Pre-1981)',
    href: '/my/vehicle/post-pre1981'
  },
  // user
  userSpotted: {
    name: 'Spotted',
    href: '/user/[name]/[id]/spotted'
  },
  userVehicles: {
    name: 'Vehicles',
    href: '/user/[name]/[id]/vehicles'
  },
  // spotted
  spotted: {
    name: 'Spotted',
    href: '/spotted',
    menu: 'View All Spotted',
    description: 'Browse the latest spotted vehicles in your area. Share your own sightings and connect with other car enthusiasts.'
  },
  spottedDetail: {
    name: 'Spotted',
    href: '/spotted/[location]/[title]'
  },
  // vehicle
  vehicleSearch: {
    name: 'Vehicles',
    menu: 'All Vehicles',
    href: '/vehicles/search',
    vCategory: 'search',
    description: ''
  },
  vehicleExotic: {
    name: 'Exotic Vehicles',
    menu: 'Exotic',
    href: '/vehicles/exotic',
    vCategory: 'exotic',
    description: 'Browse over 5,000 exotic vehicles for sale near you, including top luxury brands like Bentley, Ferrari, Lamborghini, Rolls-Royce, and more.'
  },
  vehicleLuxury: {
    name: 'Luxury Vehicles',
    menu: 'Luxury',
    href: '/vehicles/luxury',
    vCategory: 'luxury',
    description: 'Browse over 100,000 luxury vehicles for sale near you.'
  },
  vehicleSport: {
    name: 'Sport Vehicles',
    menu: 'Sport',
    href: '/vehicles/sport',
    vCategory: 'sport',
    description: 'Browse over 20,000 sport vehicles for sale near you.'
  },
  vehicleElectric: {
    name: 'Electric Vehicles',
    menu: 'Electric',
    href: '/vehicles/electric',
    vCategory: 'electric',
    description: 'Explore electric vehicles (EVs) for sale near you, including Tesla, Rivian, Hyundai, Kia, and more. Compare EV prices, features, and find your perfect electric car today!'
  },
  vehiclePhev: {
    name: 'Plugin Hybrid Vehicles',
    menu: 'Plugin Hybrid',
    href: '/vehicles/plugin-hybrid',
    vCategory: 'phev',
    description: 'Shop top plug-in hybrid electric vehicles combining electric efficiency with gas backup. Explore models with extended range, tax incentives, and flexible charging.'
  },
  vehicleHeavyHauler: {
    name: 'Heavy Haulers',
    menu: 'Heavy Hauler',
    href: '/vehicles/heavy-hauler',
    vCategory: 'heavyHauler',
    description: 'Browse powerful heavy hauler trucks and SUVs capable of towing over 10,000 lbs. Find diesel, dually, and HD models built for serious towing and tough jobs.'
  },
  vehicleOffRoad: {
    name: 'Off-Road Vehicles',
    menu: 'Off-Road',
    href: '/vehicles/off-road',
    vCategory: 'offRoad',
    description: 'Explore rugged off-road vehicles built for adventure—Jeeps, trucks, and 4x4s with high ground clearance, all-terrain tires, and trail-ready capability.'
  },
  vehicleFuelEfficient: {
    name: 'Fuel Efficient Vehicles',
    menu: 'Fuel Efficient',
    href: '/vehicles/fuel-efficient',
    vCategory: 'fuelEfficient',
    description: 'Shop top-rated fuel-efficient vehicles that save you money at the pump.'
  },
  vehicleFamily: {
    name: 'Family Favorites Vehicles',
    menu: 'Family Favorites',
    href: '/vehicles/family-favorites',
    vCategory: 'family',
    description: 'Discover top family-favorite vehicles with advanced safety features, spacious interiors, and comfort for every ride. Shop SUVs, minivans, and crossovers perfect for your family’s needs!'
  },
  vehicleAntique: {
    name: 'Antique Vehicles',
    menu: 'Antique',
    href: '/vehicles/antique',
    vCategory: 'antique',
    description: 'Explore over 3,000 antique vehicles near you, including classic models from Ford, Chevrolet, Dodge, Cadillac, ' +
      'Chrysler, GMC, Buick, Bentley, Rolls-Royce, Aston Martin, and more ...'
  },
  vehicleClassic: {
    name: 'Classic Vehicles',
    menu: 'Classic',
    href: '/vehicles/classic',
    vCategory: 'classic',
    description: 'Explore over 25,000 classic cars near you from trusted sellers. ' +
      'Find vintage muscle cars, antique trucks, and rare collectibles—perfect for collectors and enthusiasts.'
  },
  vehiclePrivate: {
    name: 'By Owner',
    menu: 'By Owner',
    href: '/vehicles/by-owner',
    vCategory: 'private',
    description: 'Browse vehicles for sale or accepting offers by owner near you. No middlemen, direct from sellers.'
  },
  vehicleCheap: {
    name: 'Vehicles Under $10,000',
    menu: 'Under $10,000',
    href: '/vehicles/under-$10000', vCategory: 'cheap',
    description: 'Browse affordable vehicles for sale near you, including used cars, trucks, and SUVs with great deals and low prices. Find your budget-friendly ride today!'
  },
  vehicleWheelchairAccessible: {
    name: 'Wheelchair Accessible Vehicles',
    menu: 'Wheelchair Accessible',
    href: '/vehicles/wheelchair-accessible', vCategory: 'wheelchairAccessible',
    description: 'Find wheelchair accessible vehicles for sale near you, including vans and SUVs with ramps, lifts, and spacious interiors designed for safe, easy mobility.'
  },
  vehicleCertified: {
    name: 'Certified Used Vehicles',
    menu: 'Certified Used',
    href: '/vehicles/certified-used', vCategory: 'certified',
    description: 'Find certified used vehicles for sale near you, including cars, trucks, and SUVs that have passed rigorous inspections and come with extended warranties.'
  },
  // dealer
  dealerVehicles: {
    name: 'Vehicles',
    href: '/vehicles/dealer/[dealer]/[location]/[id]'
  },
  // by location - for SEO
  vehicleByLocation: {
    name: '', href: '/vehicles/location/[location]',
    vCategory: 'byLocation'
  },
  // detail
  vehicleDetail: {
    name: 'Vehicle',
    href: '/vehicle/[title]/[location]'
  },
  // reserch: awards
  awards: {
    name: 'Awards', href: '/research/awards',
    description: 'Awards of the best vehicles in various categories'
  },
  // research: award-winning vehicles
  awardWinningVehicles: {
    name: 'Award-Winning Vehicles',
    href: '/research/award-winning-vehicles',
    description: 'Explore the top award-winning vehicles'
  },
  // research: popular vehicles
  popularVehicles: {
    name: 'Popular Vehicles',
    href: '/research/popular-vehicles',
    description: 'Discover the most popular vehicles in various body styles, including SUVs, trucks, sedans, and more'
  },
  // research: vehicle value
  estimateVehicleValue: {
    name: 'Estimate Vehicle Value',
    href: '/research/estimate-vehicle-value',
    description: 'Estimate the value of your vehicle with our free online tool'
  }
}

export const popularCategories = [
  pages.vehicleCheap,
  pages.vehicleCertified,
  pages.vehicleFuelEfficient,
  pages.vehiclePhev,
  pages.vehicleElectric,
  pages.vehicleFamily,
  pages.vehicleWheelchairAccessible,
  pages.vehicleHeavyHauler,
  pages.vehicleAntique,
  pages.vehicleClassic,
  pages.vehicleOffRoad,
  pages.vehicleSport,
  pages.vehicleLuxury,
  pages.vehicleExotic,
  // pages.vehiclePrivate
]

export const infoPages = [
  pages.aboutUs,
  pages.contactUs,
  pages.privacyPolicy,
  pages.termsConditions,
  pages.siteMap
]

export const researchPages = [
  pages.awards,
  pages.awardWinningVehicles,
  pages.popularVehicles,
  pages.estimateVehicleValue,
]

export const acceptImageTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp', 'image/']

export const defaultQuery = {
  spotted: {
    page_size: '24',
    page_number: '1',
    sort_id: '1',
  },
  vehicle: {
    page_size: '24',
    page_number: '1',
    sort_id: '1',
  },
  inquiries: {
    page_size: '12',
    page_number: '1',
  }
}

export const radiusOption = [
  { id: -1, name: 'Any' },
  { id: 25, name: '25 miles' },
  { id: 50, name: '50 miles' },
  { id: 100, name: '100 miles' },
  { id: 200, name: '200 miles' },
  { id: 500, name: '500 miles' },
  { id: 1000, name: '1,000 miles' },
]

export const vehicleFilterIgnoreKeys = ['sort_id', 'page_size', 'page_number', 'sort_value']